var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-text"},[_c('h1',[_vm._v("Unauthorized to vue this page.")]),_c('router-link',{attrs:{"to":"/console/login"}},[_vm._v("Return Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }